// extracted by mini-css-extract-plugin
export default {"switch":"customSwitch_switch__-k36n","slider":"customSwitch_slider__jJUdz"};